import * as React from 'react';
import {OptionDifferenceTableItem} from './OptionDifferenceTable';
import {ITranslatedComponent} from '../../redux/reducers/generalReducer';
import {translate} from 'react-i18next';
import {compose} from 'redux';

interface IOptionDifferenceRowProps extends ITranslatedComponent {
    item: OptionDifferenceTableItem;
}

const OptionDifferenceRow: React.StatelessComponent<IOptionDifferenceRowProps> = (props: IOptionDifferenceRowProps) => (
    <>
        <tr>
            {props.item.label && <td rowSpan={props.item.labelRowSpan}> <h3> <b> {props.t(props.item.label)} </b> </h3> </td>}
            <td> <div className='cell-container'> {props.item.diffValues[0].baseMarketValue} </div> </td>
            <td> <div className='cell-container'> {props.item.diffValues[0].specificMarketValue} </div> </td>
        </tr>
        {props.item.diffValues.length === 2 && props.item.labelRowSpan === props.item.diffValues.length &&
            <tr>
                <td> <div className='cell-container'> {props.item.diffValues[1].baseMarketValue} </div> </td>
                <td> <div className='cell-container'> {props.item.diffValues[1].specificMarketValue} </div> </td>
            </tr>
        }
    </>
);

export default compose<React.ComponentType<any>>(
    translate(["COLUMN_FACTORY"]),
)(OptionDifferenceRow);



// WEBPACK FOOTER //
// ./src/views/OptionDifferenceView/OptionDifferenceRow.tsx